import React from "react";
import "./BrandReadiness.scss";

// assets (sections/ → up 4 levels to /resources)
import IconStrategy  from "../../../../resources/images/brandkeeper/brand_strategy.svg";
import IconIdentity  from "../../../../resources/images/brandkeeper/brand_identity.svg";
import IconGuides    from "../../../../resources/images/brandkeeper/brand_guidelines.svg";
import IconVoice     from "../../../../resources/images/brandkeeper/brand_voice.svg";
import ArrowUp       from "../../../../resources/images/brandkeeper/arrow_up_accordion.svg";
import ArrowDown     from "../../../../resources/images/brandkeeper/arrow_down_accordion.svg";

export default function BrandReadiness() {
  return (
    <div className="br-grid" data-section="brand-readiness">
      <div className="br-band">
        {/* LEFT column */}
        <div className="br-left">
          <div className="br-left__inner">
            {/* Force EXACTLY 2 lines */}
            <h2 className="br-title">
              <span className="br-line br-line--first">Are you ready for</span>
              <span className="br-line br-line--second">brand consistency?</span>
            </h2>

            <p className="br-intro">
              Before you choose your <strong>BrandKeeper<sup>™</sup></strong> plan, check if these
              sound familiar. Each one is a common challenge for growing brands,
              and each one has a clear solution.
            </p>
          </div>
        </div>

        {/* RIGHT column — SEO-friendly details/summary */}
        <div className="br-right">
          <div className="br-right__inner" role="list">
            <details className="br-item" role="listitem" open>
              <summary className="br-item__summary">
                <img className="br-item__icon" src={IconStrategy} alt="" aria-hidden="true" />
                <span className="br-item__title">Brand strategy</span>
                <img className="br-item__chev br-item__chev--down" src={ArrowDown} alt="" aria-hidden="true" />
                <img className="br-item__chev br-item__chev--up"   src={ArrowUp}   alt="" aria-hidden="true" />
              </summary>
              <div className="br-panel">
                <p className="br-quote">
                  “We are moving fast but I am not always sure if we are aiming in the right direction.”
                </p>
                <p className="br-body">
                  A clear brand strategy gives every campaign purpose and ensures your marketing effort works harder.
                </p>
                <a className="br-link" href="/contact-us">👉 Contact us for brand strategy support</a>
              </div>
            </details>

            <details className="br-item" role="listitem">
              <summary className="br-item__summary">
                <img className="br-item__icon" src={IconIdentity} alt="" aria-hidden="true" />
                <span className="br-item__title">Visual identity system</span>
                <img className="br-item__chev br-item__chev--down" src={ArrowDown} alt="" aria-hidden="true" />
                <img className="br-item__chev br-item__chev--up"   src={ArrowUp}   alt="" aria-hidden="true" />
              </summary>
              <div className="br-panel">
                <p className="br-quote">
                  “Our logo, colors and fonts feel scattered and nothing looks consistent.”
                </p>
                <p className="br-body">
                  A strong identity system makes your brand instantly recognizable and removes guesswork from design.
                </p>
                <a className="br-link" href="/contact-us">👉 Contact us to build your brand identity</a>
              </div>
            </details>

            <details className="br-item" role="listitem">
              <summary className="br-item__summary">
                <img className="br-item__icon" src={IconGuides} alt="" aria-hidden="true" />
                <span className="br-item__title">Brand guidelines</span>
                <img className="br-item__chev br-item__chev--down" src={ArrowDown} alt="" aria-hidden="true" />
                <img className="br-item__chev br-item__chev--up"   src={ArrowUp}   alt="" aria-hidden="true" />
              </summary>
              <div className="br-panel">
                <p className="br-quote">
                  “Every channel looks different. Social posts appear one way while presentations look another.”
                </p>
                <p className="br-body">
                  Documented guidelines keep your visuals and messaging aligned no matter who is creating content.
                </p>
                <a className="br-link" href="/contact-us">👉 Contact us to create your brand guidelines</a>
              </div>
            </details>

            <details className="br-item" role="listitem">
              <summary className="br-item__summary">
                <img className="br-item__icon" src={IconVoice} alt="" aria-hidden="true" />
                <span className="br-item__title">Voice and tone</span>
                <img className="br-item__chev br-item__chev--down" src={ArrowDown} alt="" aria-hidden="true" />
                <img className="br-item__chev br-item__chev--up"   src={ArrowUp}   alt="" aria-hidden="true" />
              </summary>
              <div className="br-panel">
                <p className="br-quote">“Our copy sounds different depending on who writes it.”</p>
                <p className="br-body">
                  Defined voice and tone make your brand sound as consistent as it looks.
                </p>
                <a className="br-link" href="/contact-us">👉 Contact us to define your brand voice</a>
              </div>
            </details>
          </div>
        </div>
      </div>
    </div>
  );
}

